import React, { Component } from "react";
import { connect } from "react-redux";
import { Form, Dropdown, Grid } from "semantic-ui-react";
import axios from "axios";
import _ from "lodash";
import settings, { getApiHost } from "../../../settings";
import InlineError from "../../messages/InlineError";
import "../../../assets/styles/form-control.css";
import { expireSession } from "../../../actions/auth";
import GlbUse from "../../dialogs/GlbUse";
import { ERR_CHECKBOX_NOT_CEHCKED } from "../../../ErrorMessages";
import { setUserDisclosures } from "../../../actions/userDisclosures";

class GlbControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedGlb: undefined,
      glbs: [],
      glbCheck: false,
      defaultGlb: undefined,
      cancelTokenSource: undefined,
      active: false,
    };
  }

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.firstErrorFieldName &&
      nextProps.firstErrorFieldName === nextProps.control.FieldName
    ) {
      const element = document.getElementById(
        `chk_${nextProps.control.FieldId}`
      );
      if (element) element.focus();
    }
    if (this.state.glbs.length < 1) {
      this.loadData(nextProps);
    }
    if (
      nextProps.defaultData === undefined ||
      nextProps.defaultData[nextProps.control.FieldName] === undefined ||
      nextProps.defaultData[nextProps.control.FieldName] === ""
    ) {
      if (
        this.state.glbs !== undefined &&
        this.state.glbs.length > 0 &&
        !this.state.selectedGlb
      ) {
        const selectedGlb = {
          name: nextProps.control.FieldName,
          value: this.state.glbs[0].value,
        };
        if (this.isCompMounted) {
          this.setState({
            selectedGlb,
            // glbCheck: false,
          });
        }
      }
      if (
        nextProps.errors[nextProps.control.FieldName] !== undefined &&
        nextProps.errors[nextProps.control.FieldName] !== ""
      ) {
        const element = document.getElementById(`chk_${nextProps.FieldId}`);
        if (element) element.focus();
      }
      if (this.state.glbCheck && this.isCompMounted)
        this.setState({ glbCheck: false });
      return;
    }
    const selectedGlb = {
      name: nextProps.control.FieldName,
      value: nextProps.defaultData[nextProps.control.FieldName],
    };
    if (this.isCompMounted) {
      this.setState({
        selectedGlb,
        // glbCheck: true,
      });
    }
  }

  componentWillUnmount() {
    this.isCompMounted = false;
    if (this.state.cancelTokenSource !== undefined) {
      this.state.cancelTokenSource.cancel("Glb unmounting...");
    }
  }

  setDefaultDisclosureOption = (props, options) => {
    if (props.defaultData && props.defaultData[props.control.FieldName]) {
      const option = _.find(
        options,
        (o) => o.value === props.defaultData[props.control.FieldName]
      );
      option.name = props.control.FieldName;
      this.setState({ glbCheck: true });
      this.handleGlbSelect(this, option);
    } else {
      const defaultGlb =
        props.userGlb && props.userGlb.glb !== ""
          ? props.userGlb.glb
          : options[0].value;
      const option = _.find(options, (a) => a.value === defaultGlb);
      const defValue = options && options.length > 0 ? options[0].value : 0;
      const selOption = {
        name: props.control.FieldName,
        value: option ? option.value : defValue,
      };
      this.handleGlbSelect(this, selOption);
    }
  };

  isCompMounted = false;

  loadData = (props) => {
    this.isCompMounted = true;
    if (props.userDisclosures) {
      if (this.isCompMounted)
        this.setState({ glbs: props.userDisclosures.userDisclosures });
      this.setDefaultDisclosureOption(
        props,
        props.userDisclosures.userDisclosures
      );
      return;
    }
    const cancelTokenSource = axios.CancelToken.source();
    axios
      .post(
        `${getApiHost(settings.env)}/disclosures.aspx`,
        {
          appName: settings.appName,
          mastType: this.props.userAccount.mastType,
          mastState: this.props.userAccount.mastState,
        },
        { async: false }
      )
      .then((res) => {
        if (_.get(res, "errors.error.errType") === "unauthorized") {
          props.expireSession();
          return;
        }

        const options = [];
        _.map(res.data.Data, (state) => {
          options.push({
            key: state.DiscDesc,
            value: state.Id,
            text: state.DiscDesc,
            disc: state.DiscWording,
          });
        });
        props.setUserDisclosures(options);
        this.setDefaultDisclosureOption(props, options);
        if (this.isCompMounted) {
          this.setState({ glbs: options, cancelTokenSource: undefined });
        }
      })
      .catch((err) => {
        console.log("Glb disclosures error - ", err, " - ", err.response);
        if (err.response && err.response.status === 401) {
          props.expireSession();
          return;
        }
        this.setState({ cancelTokenSource: undefined });
      });
    if (this.isCompMounted) {
      this.setState({ cancelTokenSource });
    }
  };

  handleGlbCheck = (e) => {
    if (this.isCompMounted) {
      this.setState({ glbCheck: e.target.checked });
    }
    if (!e.target.checked)
      this.props.notifyChangeToForm(e, { name: e.target.name, value: "" });
    else if (this.state.selectedGlb !== undefined)
      this.props.notifyChangeToForm(e, {
        name: this.state.selectedGlb.name,
        value: this.state.selectedGlb.value,
      });
  };

  handleGlbSelect = (e, data) => {
    if (this.isCompMounted) {
      this.setState({
        selectedGlb: { name: data.name, value: data.value },
        defaultGlb: data.value,
      });
    }
    if (
      this.props.defaultData[this.props.control.FieldName] !== undefined &&
      this.props.notifyChangeToForm !== undefined
    )
      this.props.notifyChangeToForm(e, { name: data.name, value: data.value });
  };

  closeGlbDialog = () => this.isCompMounted && this.setState({ active: false });

  showGlbUse = () => {
    if (!this.state.active && this.isCompMounted)
      this.setState({ active: true });
  };

  render() {
    const { control, defaultData, isLeftSearch } = this.props;
    if (control === undefined) {
      return null;
    }
    const color = control.FieldRequired ? "red" : "black";
    return (
      <Grid.Row key={`drop_${control.FieldId}`}>
        <Grid.Column width={isLeftSearch ? 6 : 6}>
          <Form.Field error={!!control.error}>
            <div className={"padding-top-11"}>
              <label htmlFor={control.FieldName}>
                <input
                  key={`chk_${control.FieldId}`}
                  id={`chk_${control.FieldId}`}
                  name={`chk_${control.FieldName}`}
                  checked={this.state.glbCheck}
                  onChange={this.handleGlbCheck}
                  type="checkbox"
                  ref={(input) => {
                    this.glbCheckbox = input;
                  }}
                  className={`ui checkbox no-margin-top`}
                />{" "}
                <GlbUse
                  active={this.state.active}
                  closeGlbDialog={this.closeGlbDialog}
                  openGlbDialog={this.showGlbUse}
                  glbs={this.state.glbs}
                />
                {/* <button onClick={this.showGlbUse()}>GLB Use(*)</button> */}
                <span
                  role={"button"}
                  tabIndex={-1}
                  onClick={() => this.showGlbUse()}
                  style={{
                    color,
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  GLB Use(*)
                </span>
              </label>
            </div>
            {((this.props.errors[control.FieldName] !== undefined &&
              this.props.errors[control.FieldName] !== "") ||
              (defaultData[control.FieldName] !== undefined &&
                defaultData[control.FieldName] !== "" &&
                !this.state.glbCheck)) && (
              <InlineError text={ERR_CHECKBOX_NOT_CEHCKED} />
            )}
          </Form.Field>
        </Grid.Column>
        <Grid.Column width={isLeftSearch ? 10 : 10}>
          <Form.Field>
            {this.state.selectedGlb && (
              <Dropdown
                fluid
                selectOnBlur={false}
                selection
                id={control.FieldId}
                options={this.state.glbs}
                name={control.FieldName}
                placeholder={control.controlPlaceholder}
                value={this.state.selectedGlb.value}
                label={control.FieldLabel}
                onChange={this.handleGlbSelect}
              />
            )}
          </Form.Field>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

function mapStateToProps(state) {
  return {
    userGlb: state.glb,
    userAccount: state.userAccount,
    userDisclosures:
      state.userDisclosures && state.userDisclosures.userDisclosures
        ? state.userDisclosures.userDisclosures
        : undefined,
  };
}

export default connect(mapStateToProps, { expireSession, setUserDisclosures })(
  GlbControl
);



// WEBPACK FOOTER //
// ./src/components/forms/controls/GlbControl.js